/** Signup nationality dropdown — 0 is reserved for searching every school. */
export const SIGNUP_ALL_COUNTRY_ID = 0;

export const isSignupAllCountries = (countryId: unknown): boolean =>
  Number(countryId) === SIGNUP_ALL_COUNTRY_ID;

export const isSignupCountryChosen = (countryId: unknown): boolean =>
  countryId !== '' && countryId !== undefined && countryId !== null;

/** Request enough options when All nationalities is selected. */
export const SIGNUP_ALL_COLLEGE_SEARCH_SIZE = 5000;
